<div class="modal-body">
  <div class="row mb-32">
    <div class="col-12" class="d-flex justify-content-center align-items-center">
      <img src="assets/img/shared/confirm-icon.png" class="" alt="">
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-center poppins mb-32">
      <p class="header-text">CONFIRM LEAGUE CREATION</p>
      <p class="sub-text">Please review the league details before proceeding. Are you sure everything is correct?</p>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex justify-content-evenly align-items-center poppins">
      <button type="button" class="btn-cancel">Cancel</button>
      <button type="button" class="btn-confirm">Confirm</button>
    </div>
  </div>
</div>